/**
 * Site-wide quote carousel functionality
 */
jQuery(function($){
    $('.quote-carousel').cycle({
        autoHeight: 'calc',
    });
});
